import { render } from "./Team_post_investment_operation.vue?vue&type=template&id=b89b652c&scoped=true"
import script from "./Team_post_investment_operation.vue?vue&type=script&lang=js"
export * from "./Team_post_investment_operation.vue?vue&type=script&lang=js"

import "./Team_post_investment_operation.vue?vue&type=style&index=0&id=b89b652c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b89b652c"

export default script